<template>
  <div class="shot">
    <img :src="$getThemeImagePath(src)" alt="操作画面" loading="lazy" @click="isZoom = true">
    <button type="button" aria-label="画像を拡大" @click="isZoom = true">
      画像を拡大 ↗
    </button>
    <div v-if="isZoom" class="help-lightbox" @click.self="isZoom = false">
      <div class="help-lightbox-inner">
        <button type="button" aria-label="閉じる" @click="isZoom = false">
          ✕ 閉じる
        </button>
        <img :src="$getThemeImagePath(src)" alt="拡大画像">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TigerShot',
  props: {
    // 主題圖片路徑（$getThemeImagePath 用）
    src: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isZoom: false
    }
  }
}
</script>
